import { render, staticRenderFns } from "./ConversationMessages.vue?vue&type=template&id=6124c792&scoped=true&"
import script from "./ConversationMessages.vue?vue&type=script&lang=js&"
export * from "./ConversationMessages.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessages.vue?vue&type=style&index=0&id=6124c792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124c792",
  null
  
)

export default component.exports